// extracted by mini-css-extract-plugin
export default {"noPriceText":"NoPrice_noPriceText__TjPnk","small":"NoPrice_small__9Tr54"};